module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.ybordersData,
      "height": _vm.wheight - 500
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "label": "订单号",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bn",
      "label": "商品货号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nums",
      "label": "数量",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "实际销售单价",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "总金额",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_commission",
      "label": "佣金",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_status",
      "label": "订单状态",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_status == '100') ? _c('el-tag', [_vm._v("已支付")]) : (scope.row.order_status == '105') ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("退款中")]) : (scope.row.order_status == '110') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已退款")]) : (scope.row.order_status == '120') ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("已支付已发货")]) : (scope.row.order_status == '130') ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已支付已退货")]) : (scope.row.order_status == '140') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已退货已退款")]) : (scope.row.order_status == '150') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已成交")]) : (scope.row.order_status == '160') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已作废")]) : (scope.row.order_status == '170') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已分佣")]) : (scope.row.order_status == '180') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("分佣已停止")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "billing_status",
      "label": "结算状态",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.billing_status == '1') ? _c('el-tag', [_vm._v("已结算")]) : (scope.row.billing_status == '2') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("结算失败")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("未结算")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "member_id",
      "label": "B2C会员ID",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "怡贝会员ID",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "store_name",
      "label": "店铺名称",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "英克ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "send_type",
      "label": "配送类型",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yb_createtime_date",
      "label": "下单时间",
      "width": "170"
    }
  })], 1), _vm._v(" "), (_vm.total_count > _vm.pageSize) ? _c('div', {
    staticClass: "content-padded tc"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total_count,
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e9a068e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9a068e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/sharer/members/orderlist.vue
// module id = 2962
// module chunks = 0